"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _themeGet = require("@styled-system/theme-get");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Container = _styledComponents["default"].div.withConfig({
  componentId: "sc-497jtd-0"
})(["display:grid;width:100%;grid-row-gap:", "px;", "{grid-template:repeat(1,1fr) / repeat(", ",1fr);grid-gap:", "px;}"], (0, _themeGet.themeGet)('space.2'), (0, _themeGet.themeGet)('mediaQueries.lg'), function (props) {
  return props.columns;
}, function (props) {
  return props.spacing;
});

var GridItem = _styledComponents["default"].div.withConfig({
  componentId: "sc-497jtd-1"
})(["display:flex;justify-content:center;"]);

function Grid(_ref) {
  var className = _ref.className,
      columns = _ref.columns,
      spacing = _ref.spacing,
      children = _ref.children;
  return _react["default"].createElement(Container, {
    className: className,
    columns: columns,
    spacing: spacing
  }, _react["default"].Children.map(children, function (child, index) {
    return _react["default"].createElement(GridItem, {
      key: index
    }, child);
  }));
}

Grid.displayName = 'Grid';
Grid.propTypes = {
  className: _propTypes["default"].string,
  columns: _propTypes["default"].number,
  spacing: _propTypes["default"].number,
  children: _propTypes["default"].node
};
Grid.defaultProps = {
  className: '',
  columns: 3,
  spacing: 16
};

var _default = (0, _react.memo)(Grid);

exports["default"] = _default;